<template>
    <div class="row justify-content-center">
        <study-list-item v-for="item in studyProducts"
                         :key="item.idstudyproduct"
                         :studyProduct="item"
                         @click.native="toStudyProduct(item)"
        />
    </div>
</template>

<script>
    import StudyListItem from "./StudyListItem";
    import studyProductApi from "../../data/StudyProductApi";

    export default {
        name: "StudyList",
        components: {StudyListItem},
        data() {
            return {
                studyProducts: [],
                loading: false,
                error: null,
            }
        },
        mounted() {
            this.loading = true
            studyProductApi.fetchStudyProducts()
                .then(response => {
                    this.studyProducts = response
                })
                .catch(error => {
                    let data = error.response.data
                    this.error = this.pretty(data)
                    this.loading = false
                })
        },
        methods: {
            toStudyProduct(studyProduct) {
                this.$router.push('/study/' + studyProduct.idstudyproduct)
            }
        }

    }
</script>

<style scoped>

</style>
